import clsx from 'clsx'
import {useEffect, useMemo, useState} from 'react'
import {useTable, usePagination, useSortBy, useRowSelect} from 'react-table'

import {ToastMessageContainer} from '../../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {toAbsoluteUrl} from '../../../../../../../_ePulse/helpers'
import {TokenNoCustomHeader} from './columns/TokenNoCustomHeader'
import {TokenNoCell} from './columns/TokenNoCell'
import {PatientNameCustomHeader} from './columns/PatientNameCustomHeader'
import {PatientNameCell} from './columns/PatientNameCell'
import {AppointmentTypeCustomHeader} from './columns/AppointmentTypeCustomHeader'
import {AppointmentTypeCell} from './columns/AppointmentTypeCell'
import {AppointmentTimeCustomHeader} from './columns/AppointmentTimeCustomHeader'
import {AppointmentTimeCell} from './columns/AppointmentTimeCell'
import {ActionCustomHeader} from './columns/ActionCustomHeader'
import {ActionsCell} from './columns/ActionCell'
import {CancelCustomHeader} from './columns/CancelHeader'
import {CancelCell} from './columns/CancelCell'
import {AgeCustomHeader} from './columns/AgeCustomHeader'
import {AgeCell} from './columns/AgeCell'
import {RXListingHeader} from '../components/header'
import useApi from '../../../../../../../hooks/useQuery'
import moment from 'moment'
import {
  GET_DOCTOR_APPOINTMENT_ON_DATE_BY_STATUS,
  CANCEL_DOCTOR_APPOINTMENTS,
  GET_CLINIC_APPOINTMENT_ON_DATE_BY_STATUS,
} from '../../../../GraphQLQueries/Dashboard'
import {useSelector} from 'react-redux'
import {LoadingSpinner} from '../../../../../../../_ePulse/layout/components/LoadingSpinner'
import {Checkbox} from '@mui/material'
import useMutationApi from '../../../../../../../hooks/useMutation'
import {toast} from 'react-toastify'
import {Modal} from 'react-bootstrap'
import '../../../../../../../App.css'

export const AppointmentListTable = () => {
  const [pageNumber, setpageNumber] = useState(1)
  const [limit, setlimit] = useState(20)
  const [totalPages, settotalPages] = useState(1)
  const [mainTab, setMainTab] = useState('Confirmed')
  const [confirmModal, setConfirmModal] = useState(false)
  // const [mainTab, setMainTab] = useState('Completed')
  const dataUser: any = useSelector((state) => {
    return state
  })

  const {
    createData,
    loading: cancelApptLoading,
    error: cancelApptError,
    data: cancelApptData,
  } = useMutationApi(CANCEL_DOCTOR_APPOINTMENTS)

  const columnsData = [
    ...(mainTab === 'Confirmed'
      ? [
          {
            Header: ({getToggleAllRowsSelectedProps}: any) => (
              <Checkbox
                style={{padding: '0px', margin: '0px'}}
                {...getToggleAllRowsSelectedProps()}
              />
            ),
            id: 'selectRow',
            Cell: ({row}: any) => <Checkbox {...row.getToggleRowSelectedProps()} />,
          },
        ]
      : []),
    {
      Header: (props: any) => (
        <TokenNoCustomHeader
          tableProps={props}
          title='Token No.'
          className='d-flex ms-5 text-black  '
        />
      ),
      accessor: 'tokenNo',
      id: 'tokenNo',
      Cell: (props: any) => <TokenNoCell tableProps={props.data[props.row.index]} />,
    },

    {
      Header: (props: any) => (
        <PatientNameCustomHeader
          tableProps={props}
          title='Patient Name'
          className='d-flex ms-5 text-black  '
        />
      ),
      accessor: 'patientname',
      id: 'patientname',
      Cell: (props: any) => (
        <PatientNameCell
          tableProps={props.data[props.row.index]}
          refetch={() => {
            refectchappointments({
              date: moment().format('YYYY-MM-DD'),
              doctorId: dataUser?.auth?.userId,
              timeZone: getTimeZone(),
              appointmentStatus: mainTab,
              page: 1,
              limit: limit,
            }).then((data: any) => {
              const res = data?.data?.getDoctorAppointmentOnDateByStatus
              setList(res?.data || [])
              setlimit(res?.pageSize || 20)
              setpageNumber(res?.page || 1)
              settotalPages(res?.totalPages || 1)
            })
          }}
        />
      ),
    },

    {
      Header: (props: any) => (
        <AgeCustomHeader tableProps={props} title='Age' className='d-flex ms-5 text-black' />
      ),
      id: 'age',
      Cell: (props: any) => <AgeCell tableProps={props.data[props.row.index]} />,
    },

    {
      Header: (props: any) => (
        <AppointmentTypeCustomHeader
          tableProps={props}
          title='Appointment Type'
          className='d-flex ms-5 text-black  '
        />
      ),
      accessor: 'appointmentType',
      id: 'appointmentType',
      Cell: (props: any) => <AppointmentTypeCell tableProps={props.data[props.row.index]} />,
    },
    {
      Header: (props: any) => (
        <AppointmentTimeCustomHeader
          tableProps={props}
          title='Appointment Time'
          className='d-flex ms-5 text-black  '
        />
      ),
      accessor: 'appointmentTime',
      id: 'appointmentTime',
      Cell: (props: any) => <AppointmentTimeCell tableProps={props.data[props.row.index]} />,
    },

    {
      Header: (props: any) => (
        <ActionCustomHeader
          tableProps={props}
          title='RX On Fly'
          className='d-flex ms-5 text-black'
        />
      ),
      id: 'rxOnFly',
      Cell: (props: any) => <ActionsCell tableProps={props.data[props.row.index]} />,
    },
    {
      Header: (props: any) => (
        <CancelCustomHeader
          tableProps={props}
          title='Cancel Appointment'
          className='d-flex ms-5 text-black'
        />
      ),
      id: 'cancelAppointment',
      Cell: (props: any) => (
        <CancelCell
          tableProps={props.data[props.row.index]}
          refetch={() => {
            refectchappointments({
              date: moment().format('YYYY-MM-DD'),
              doctorId: dataUser?.auth?.userId,
              timeZone: getTimeZone(),
              appointmentStatus: mainTab,
              page: 1,
              limit: limit,
            }).then((data: any) => {
              const res = data?.data?.getDoctorAppointmentOnDateByStatus
              setList(res?.data || [])
              setlimit(res?.pageSize || 20)
              setpageNumber(res?.page || 1)
              settotalPages(res?.totalPages || 1)
            })
          }}
        />
      ),
    },
  ]

  const getTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  const {
    data: data1,
    loading,
    error,
    refetch: refectchappointments,
  } = useApi(
    true,
    dataUser?.auth?.businessProfileRole === 'Staff'
      ? GET_CLINIC_APPOINTMENT_ON_DATE_BY_STATUS
      : GET_DOCTOR_APPOINTMENT_ON_DATE_BY_STATUS,
    {
      date: moment().format('YYYY-MM-DD'),
      doctorId: dataUser?.auth?.userId,
      timeZone: getTimeZone(),
      appointmentStatus: mainTab,
      page: pageNumber,
      limit: limit,
    }
  )
  const [listing, setList] = useState([])

  useEffect(() => {
    if (data1) {
      let res: any = []
      if (dataUser?.auth?.businessProfileRole === 'Staff') {
        res = data1?.getClinicAppointmentsOnDateByStatus
      } else {
        res = data1?.getDoctorAppointmentOnDateByStatus
      }
      console.log('res', res)
      // const res = data1?.getDoctorAppointmentOnDateByStatus?.data
      setList(res?.data)
      setlimit(res.pageSize || 20)
      setpageNumber(res.page)
      settotalPages(res.totalPages)
    }
  }, [data1, mainTab])

  const data = listing
  const [columns, setColumns] = useState(columnsData)

  useEffect(() => {
    setColumns(
      mainTab === 'Confirmed'
        ? [
            {
              Header: ({getToggleAllRowsSelectedProps}: any) => (
                <Checkbox
                  style={{padding: '0px', margin: '0px'}}
                  {...getToggleAllRowsSelectedProps()}
                />
              ),
              id: 'selectRow',
              Cell: ({row}: any) => (
                <div className='d-flex '>
                  <Checkbox className='text-black' {...row.getToggleRowSelectedProps()} />
                </div>
              ),
            },
            ...columnsData.slice(1),
          ]
        : columnsData.slice(1)
    )
  }, [mainTab])

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    usePagination,
    useRowSelect
  )
  const {
    getTableProps,
    getTableBodyProps,
    headers,
    rows,
    prepareRow,
    state: {pageSize},
    setPageSize,
  }: any = tableInstance

  const selectedRows = rows.filter((row: any) => row.isSelected)

  const handleCancelAppointment = async () => {
    const selectedAppointments = selectedRows.map((row: any) => row.original)
    const appointmentIds = selectedAppointments.map((appointment: any) => appointment.id)

    try {
      const response = await createData({appointmentIds, timeZone: getTimeZone()})

      const {total, cancelled, failed} = response?.data?.cancelDoctorAppointments?.summary || {}

      if (cancelled > 0) {
        toast.success(`${cancelled} out of ${total} appointments have been cancelled successfully.`)
      }

      if (failed > 0) {
        toast.error(`${failed} out of ${total} appointments failed to cancel.`)
      }

      refectchappointments()
    } catch (error) {
      toast.error('An error occurred while cancelling appointments.')
    }
    setConfirmModal(false)
  }

  return (
    <div>
      <ToastMessageContainer />
      <LoadingSpinner isLoading={loading | cancelApptLoading} />
      <RXListingHeader
        mainTab={mainTab}
        changeMainTab={(selected: any) => {
          setMainTab(selected)
          refectchappointments({
            date: moment().format('YYYY-MM-DD'),
            doctorId: dataUser?.auth?.userId,
            timeZone: getTimeZone(),
            appointmentStatus: selected,
            page: 1,
            limit: limit,
          })
        }}
        refresh={() => {
          refectchappointments({
            date: moment().format('YYYY-MM-DD'),
            doctorId: dataUser?.auth?.userId,
            timeZone: getTimeZone(),
            appointmentStatus: mainTab,
            page: 1,
            limit: limit,
          })
        }}
      />
      <div>
        <Modal
          show={confirmModal}
          dialogClassName='ePulse-modal ePulse-modal-50w'
          onHide={() => setConfirmModal(false)}
          backdrop='static'
        >
          <Modal.Header closeButton>
            <span className='fs-3 fw-bold'>Cancel Appointment</span>
          </Modal.Header>
          <Modal.Body className='container'></Modal.Body>
          <div className='ePulse-modal-content'>
            <div className='bg-white rounded p-3 '>
              <span>Are you sure you want to cancel appointment?</span>
            </div>

            <div className='btn-row'>
              <button
                className='ePulse-btn-primary'
                type='button'
                onClick={() => handleCancelAppointment()}
              >
                Yes
              </button>
              <button
                className='ePulse-btn-secondory ms-2'
                type='button'
                onClick={() => {
                  setConfirmModal(false)
                  // setmodalState(false)
                  // props.refetch()
                }}
              >
                No
              </button>
            </div>
          </div>
        </Modal>
      </div>
      <div className='admin-table'>
        <table {...getTableProps()} className='table '>
          <thead>
            <tr className='text-center text-dark fw-bolder fs-6 MyReactTableClass '>
              {headers.map((column: any, index: number) => {
                return (
                  <th
                    className={clsx({
                      'pbb-18': column.id !== 'selectRow',
                    })}
                    key={index}
                    // className={
                    //   column?.isSorted === false && column?.canSort
                    //     ? 'sortable'
                    //     : column?.isSorted === true && column?.isSortedDesc === false
                    //     ? 'sortable asc'
                    //     : column?.isSorted === true && column?.isSortedDesc === true
                    //     ? 'sortable desc'
                    //     : ''
                    // }
                    // {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render('Header')}
                  </th>
                )
              })}
            </tr>
          </thead>

          <tbody className='text-black fw-normal text-center' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: any, index: number) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()} className={index === 0 ? 'bg-white' : 'bg-white'}>
                    {row.cells.map((cell: any) => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className={clsx({
                            'text-end min-w-100px p-1 pt-18px': cell.column.id === 'actions',
                            'ptt-18': cell.column.id !== 'selectRow',
                          })}
                        >
                          {cell.render('Cell')}
                        </td>
                      )
                    })}
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <Pagination /> */}
        {selectedRows.length > 0 && (
          <div className={'d-flex justify-content-end mb-5'}>
            <div></div>
            <button className='ePulse-button' onClick={() => setConfirmModal(true)}>
              Cancel Appointment
            </button>
          </div>
        )}

        {listing.length > 0 && (
          <div className='pagination'>
            <div className='page-show'>
              <span>Show Entries</span>
              <select
                className='ms-2 ePulse-pagination-dropdown'
                value={limit}
                onChange={(e) => {
                  setlimit(parseInt(e.target.value))
                  setpageNumber(1)
                  refectchappointments({
                    date: moment().format('YYYY-MM-DD'),
                    doctorId: dataUser?.auth?.userId,
                    timeZone: getTimeZone(),
                    appointmentStatus: mainTab,
                    page: 1,
                    limit: parseInt(e.target.value),
                  })
                }}
              >
                {[10, 20, 30, 40, 50, 100, 500].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>
            <div className='page-num'>
              <button
                className={
                  pageNumber === 1
                    ? 'ePulse-pagination-button'
                    : clsx('ePulse-pagination-button text-white')
                }
                onClick={() => {
                  setpageNumber(pageNumber - 1)
                  refectchappointments({
                    date: moment().format('YYYY-MM-DD'),
                    doctorId: dataUser?.auth?.userId,
                    timeZone: getTimeZone(),
                    appointmentStatus: mainTab,
                    page: pageNumber - 1,
                    limit: limit,
                  })
                }}
                disabled={pageNumber === 1}
              >
                <img alt='Previous' src={toAbsoluteUrl('/media/icons/duotune/arrows/arr022.svg')} />
              </button>
              <span className='mx-3'>
                Page{' '}
                <strong>
                  {pageNumber} of {totalPages}
                </strong>{' '}
              </span>
              <button
                className={
                  pageNumber === totalPages
                    ? 'ePulse-pagination-button'
                    : clsx('ePulse-pagination-button text-white')
                }
                onClick={() => {
                  setpageNumber(pageNumber + 1)
                  refectchappointments({
                    date: moment().format('YYYY-MM-DD'),
                    doctorId: dataUser?.auth?.userId,
                    timeZone: getTimeZone(),
                    appointmentStatus: mainTab,
                    page: pageNumber + 1,
                    limit: limit,
                  })
                }}
                disabled={pageNumber === totalPages}
              >
                <img alt='Next' src={toAbsoluteUrl('/media/icons/duotune/arrows/arr023.svg')} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
